import { render, staticRenderFns } from "./SourceEdit.vue?vue&type=template&id=8deca9da&"
import script from "./SourceEdit.vue?vue&type=script&lang=ts&"
export * from "./SourceEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports